module.exports = __webpack_public_path__ + "media/Video 125.f8041719.mp4";